export enum LanguagePreference {
  LATVIAN = 'lv',
  ENGLISH = 'en',
}
